import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete, Button, Form, Grid, Heading, Input, Modal, Panel, Radio, Textblock, Select, Validation,
} from 'framework-ui-components';
import InfoesIcon from 'framework-ui-components/Components/Icons/InfoesIcon';
import { codiceFiscaleValido } from 'framework-ui-components/Components/Validation';
import { TipoDichiarazione, DichiarazioneIntegrativaObbligatorietaProtocollo } from 'enums';
import { cercaAnagraficaInUfficio } from 'apis/anagraficaApi';
import { esisteDichiarazionePerAnagrafica, protocolloIntegrativaObbligatorio } from 'apis/setteTrentaApi';
import { creaSostitutoImposta, sostitutoImposta } from 'apis/sostitutiApi';
import { renderMessaggi, renderPulsanti } from './gestoreModale';

Validation.register(
  'CodiceFiscaleAlfaNumericoTrimmed',
  (x, y) => !codiceFiscaleValido((x || '').trim()), { message: 'Codice Fiscale non valido' },
);

Validation.register(
  'ValidaCognome',
  (x, y) => /[0-9]/.test(x), { message: 'Il cognome deve contenere solo lettere' },
);

Validation.register(
  'ValidaNome',
  (x, y) => /[0-9]/.test(x), { message: 'Il nome deve contenere solo lettere' },
);

const _tipoDichiarazione = {
  NON_SELEZIONATO: 0,
  ORDINARIA: 'ordinaria',
  INTEGRATIVA: 'integrativa',
};

const FORM_INITIAL_STATE = {
  IdAnagrafica: null,
  IdSostituoImpostaPrecedente: null,
  sostitutoPrecedente: {

  },
  dichiarazioneEsistente: null,
  CodiceFiscale: '',
  Cognome: '',
  Nome: '',
  TipoDichiarazione: _tipoDichiarazione.NON_SELEZIONATO,
  Protocollo: '',
  windowMessage: '',
  caricandoModale: false,
  obbligatorioCodice1: DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo,
  obbligatorioCodice2: DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo,
  obbligatorioCodice3: DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo,
  DataPrimaRata: 0,
  SceltaSostituto: 1,
  Sostituto: null,
};

class ModaleCreazione extends Component {
  state = {
    ...FORM_INITIAL_STATE,
    bloccaInserimento: true,
    caricandoModale: false,
    cfValidoSiatel: true,
    DescrizioneComue: '',
    TipologiaIndirizzo: '',
  }

  componentDidMount() {
    const { datiIniziali, tipoDichiarazione, ufficioSelezionato } = this.props;

    if (tipoDichiarazione == _tipoDichiarazione.ORDINARIA) {
      this.setState({ TipoDichiarazione: TipoDichiarazione.Ordinaria });
    }
    if (tipoDichiarazione == _tipoDichiarazione.INTEGRATIVA) {
      this.setState({ TipoDichiarazione: TipoDichiarazione.SetteTrentaIntegrativaCodice2 });
    }
    if (datiIniziali) {
      this.setState(datiIniziali, () => {
        this.cercaAnagraficaInUfficio(datiIniziali.CodiceFiscale, ufficioSelezionato);
        this.valutaObbligatorietaProtocollo(datiIniziali.CodiceFiscale);
      });
      this.setState({ TipoDichiarazione: TipoDichiarazione.SetteTrentaIntegrativaCodice2 });
    }

    this.cfInput && this.cfInput.focus();
  }

  componentWillReceiveProps(nextProps) {
    const { datiIniziali, tipoDichiarazione } = this.props;

    if (tipoDichiarazione != nextProps.tipoDichiarazione && nextProps.tipoDichiarazione == _tipoDichiarazione.ORDINARIA) {
      this.setState({ TipoDichiarazione: TipoDichiarazione.Ordinaria });
    }
    if (tipoDichiarazione != nextProps.tipoDichiarazione && nextProps.tipoDichiarazione == _tipoDichiarazione.INTEGRATIVA) {
      this.setState({ TipoDichiarazione: TipoDichiarazione.SetteTrentaIntegrativaCodice1 });
    }
    if (datiIniziali != nextProps.datiIniziali && nextProps.datiIniziali) {
      this.setState(nextProps.datiIniziali, () => {
        this.cercaAnagraficaInUfficio(nextProps.datiIniziali.CodiceFiscale, nextProps.ufficioSelezionato);
        this.valutaObbligatorietaProtocollo(nextProps.datiIniziali.CodiceFiscale);
      });
      this.setState({ TipoDichiarazione: TipoDichiarazione.SetteTrentaIntegrativaCodice1 });
    }
  }

  annulla = () => {
    this.setState(FORM_INITIAL_STATE, () => this.props.onAnnulla && this.props.onAnnulla());
  }

  crea = () => {
    if (this.form.valida()) {
      if (this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2
        && this.state.SceltaSostituto == 1
        && this.state.Sostituto && !this.state.Sostituto.IdSostituto) {
        const cmd = {
          ...this.state.Sostituto,
          CodiceUfficio: this.props.ufficioSelezionato,
          CodiceSede: this.state.Sostituto.CodiceSede || 0,
          CodiceFiscale: this.state.CodiceFiscaleSostituto,
          Anno: this.props.annoSelezionato,
        };
        creaSostitutoImposta(cmd)
          .then((res) => {
            if (res.Success) {
              const sostituto = {
                ...this.state.Sostituto,
                IdSostituto: res.Response.IdSostitutoImposta,
              };
              this.setState({ Sostituto: sostituto }, () => this.props.onCreaNuova && this.props.onCreaNuova(this.state));
            }
          });
      } else {
        this.props.onCreaNuova && this.props.onCreaNuova(this.state);
      }
    }
  }

  modifica = () => {
    const { anniRegistrati, annoSelezionato } = this.props;
    const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;
    window.location.href = `${url}#/Frontespizio/${this.state.dichiarazioneEsistente.IdDichiarazione.split('/')[1]}`;
  }

  updateForm = (data) => {
    if (data.TipoDichiarazione && data.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice1
      && this.state.obbligatorioCodice1 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      data.Protocollo = null;
    } else if (data.TipoDichiarazione && data.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2
      && this.state.obbligatorioCodice2 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      data.Protocollo = null;
    } else if (data.TipoDichiarazione && data.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice3
      && this.state.obbligatorioCodice3 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      data.Protocollo = null;
    }

    this.setState(data);
  }

  ripristina = () => {
    this.form.valida() && this.props.onRipristinaEliminata && this.props.onRipristinaEliminata(this.state);
  }

  visualizza = () => {
    const { anniRegistrati, annoSelezionato } = this.props;
    const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;
    window.location.href = `${url}#/Frontespizio/Visualizza/${this.state.dichiarazioneEsistente.IdDichiarazione.split('/')[1]}`;
  }

  incolla = (e) => {
    const str = e.clipboardData.getData('Text');
    e.preventDefault();
    this.setState({ CodiceFiscale: str.trim() }, () => this.valutaEsistenzaAnagrafica({ target: { value: str.trim() } }));
  }

  valutaEsistenzaAnagrafica = (evt) => {
    const value = evt.target.value.trim();

    if (/^[A-Za-z0-9]{16}$/.test(value)) {
      this.cercaAnagraficaInUfficio(value, this.props.ufficioSelezionato);
      this.valutaObbligatorietaProtocollo(value);
    } else {
      // svuota campi
      this.setState({
        Cognome: '', Nome: '', bloccaInserimento: true, dichiarazioneEsistente: null,
      });
    }
  }

  cercaAnagraficaInUfficio = (codiceFiscale, ufficio) => {
    this.setState({ caricandoModale: true }, () => {
      cercaAnagraficaInUfficio(codiceFiscale, ufficio)
        .then((res) => {
          if (res) {
            //  Esiste e valorizzo
            this.setState({
              bloccaInserimento: true,
              caricandoModale: false,

              Cognome: res.Cognome,
              Nome: res.Nome,
              IdAnagrafica: res.IdAnagrafica,
            }, () => {
              // Controllo se esiste una dichiarazione
              esisteDichiarazionePerAnagrafica(this.state.CodiceFiscale, this.props.ufficioSelezionato, this.state.TipoDichiarazione, this.props.annoSelezionato)
                .then((ex) => {
                  ex && this.setState({ dichiarazioneEsistente: ex, IdSostituoImpostaPrecedente: ex.IdSostitutoImposta });
                  if (ex != null && ex.IdSostitutoImposta != null) {
                    sostitutoImposta(ex.IdSostitutoImposta).then(zz => this.setState({ sostitutoPrecedente: zz || { IdSostituto: 0 } }));
                  } else {
                    this.setState({ sostitutoPrecedente: { IdSostituto: 0 } });
                  }
                });
            });
          } else {
            //  Non esiste
            this.setState({ caricandoModale: false, bloccaInserimento: false });
          }
        });
    });
  }

  valutaObbligatorietaProtocollo(value) {
    if (this.state.TipoDichiarazione && this.state.TipoDichiarazione != TipoDichiarazione.Ordinaria && value && value.length == 16) {
      protocolloIntegrativaObbligatorio(value, this.props.ufficioSelezionato, this.props.annoSelezionato)
        .then((res) => {
          this.setState({ obbligatorioCodice1: res.ObbligatorioCodice1, obbligatorioCodice2: res.ObbligatorioCodice2, obbligatorioCodice3: res.ObbligatorioCodice3 });
        });
    }
  }

  validaProtocollo(annoSelezionato) {
    const errorMessage = 'Il testo deve essere di 17 caratteri.';
    let validations = [];

    if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice1
      && this.state.obbligatorioCodice1 == DichiarazioneIntegrativaObbligatorietaProtocollo.Obbligatorio) {
      validations = ['required', { rule: 'minLength', minLength: 17, message: errorMessage }, { rule: 'maxLength', maxLength: 18, message: errorMessage }, { rule: 'Pattern', pattern: new RegExp(`${annoSelezionato % 100}[0-9]{14}[0-9]`, 'i'), message: 'Protocollo non valido' }];
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2
      && this.state.obbligatorioCodice2 == DichiarazioneIntegrativaObbligatorietaProtocollo.Obbligatorio) {
      validations = ['required', {
        rule: 'minLength', minLength: 17, message: errorMessage,
      }, { rule: 'maxLength', maxLength: 18, message: errorMessage }, { rule: 'Pattern', pattern: new RegExp(`${annoSelezionato % 100}[0-9]{14}[0-9]`, 'i'), message: 'Protocollo non valido' }];
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice3
      && this.state.obbligatorioCodice3 == DichiarazioneIntegrativaObbligatorietaProtocollo.Obbligatorio) {
      validations = ['required', { rule: 'minLength', minLength: 17, message: errorMessage }, { rule: 'maxLength', maxLength: 18, message: errorMessage }];
    } else if (this.state.TipoDichiarazione
      && (this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice1 && this.state.obbligatorioCodice1 == DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo && this.state.Protocollo)
      || (this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2 && this.state.obbligatorioCodice2 == DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo && this.state.Protocollo)
      || (this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice3 && this.state.obbligatorioCodice3 == DichiarazioneIntegrativaObbligatorietaProtocollo.Facoltativo && this.state.Protocollo)) {
      validations = [{ rule: 'minLength', minLength: 17, message: errorMessage }, { rule: 'maxLength', maxLength: 18, message: errorMessage }, { rule: 'Pattern', pattern: new RegExp(`${annoSelezionato % 100}[0-9]{14}[0-9]`, 'i'), message: 'Protocollo non valido' }];
    }

    return validations;
  }

  abilitaProtocollo() {
    let disabled = false;
    if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice1
      && this.state.obbligatorioCodice1 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      disabled = true;
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2
      && this.state.obbligatorioCodice2 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      disabled = true;
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice3
      && this.state.obbligatorioCodice3 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      disabled = true;
    }
    return disabled;
  }

  titleProtocollo() {
    let title = 'Numero protocollo';
    if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice1
      && this.state.obbligatorioCodice1 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      title = 'Protocollo non richiesto';
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2
      && this.state.obbligatorioCodice2 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      title = 'Protocollo non richiesto';
    } else if (this.state.TipoDichiarazione && this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice3
      && this.state.obbligatorioCodice3 == DichiarazioneIntegrativaObbligatorietaProtocollo.NonRichiesto) {
      title = 'Protocollo non richiesto';
    }
    return title;
  }

  changeSceltaSostituto = (evt) => {
    if (evt.target.value == 0) {
      this.setState({ CodiceFiscaleSostituto: null, Sostituto: null });
    }
    if (evt.target.value == 1) {
      this.setState({ CodiceIban: null });
    }
  }

  changeCodiceFiscaleSostituto = (sost) => {
    if (typeof (sost) == 'string') {
      const { Sostituto } = this.state;
      const sost = { CodiceFiscale: sost };
      this.setState(Object.assign({ Sostituto: sost }, Sostituto && Sostituto.IdSostituto ? { TipologiaIndirizzo: null, DescrizioneComune: null } : {}));
    }

    if (typeof (sost) == 'object') {
      this.setState({
        Sostituto: sost, DescrizioneComune: sost.DescrizioneComue, TipologiaIndirizzo: sost.TipologiaIndirizzo, CodiceFiscaleSostituto: sost.CodiceFiscale,
      });
    }
  }

  changeTipoIndirizzoSostituto = (tipo) => {
    const sostituto = {
      ...this.state.Sostituto,
      TipologiaIndirizzo: (tipo && tipo.Descrizione) || null,
    };

    this.setState({ Sostituto: sostituto, TipologiaIndirizzo: tipo.Descrizione });
  }

  changeComuneSostituto = (comune) => {
    const sostituto = {
      ...this.state.Sostituto,
      CodiceComune: comune.CodiceComune,
      Cap: comune.Cap,
      DescrizioneComune: comune.Descrizione,
      CodiceProvincia: comune.CodiceProvincia,
    };

    this.setState({ Sostituto: sostituto, DescrizioneComune: comune.Descrizione });
  }

  render() {
    const {
      showModal, tipoDichiarazione, isLoading, messaggioErrore, datiIniziali, ufficioSelezionato, annoSelezionato, impostazioni,
    } = this.props;
    const {
      bloccaInserimento, windowMessage, caricandoModale, dichiarazioneEsistente, sostitutoPrecedente, DescrizioneComune, TipologiaIndirizzo,
    } = this.state;

    return (
      <Modal show={showModal} onClose={this.annulla} loading={isLoading || caricandoModale}>
        <Modal.Header>
          {datiIniziali ? `Nuova integrativa per ${datiIniziali.Cognome} ${datiIniziali.Nome}` : `Nuova dichiarazione ${tipoDichiarazione}`}
          {tipoDichiarazione === _tipoDichiarazione.INTEGRATIVA && (
            <a
              target="_blank"
              href={`${window.config.urlAssistente}/#/Area/1/Dossier/182/Contenuto/10405`}
              className="infoTooltip"
              style={{ marginLeft: '5px' }}
            >
              <InfoesIcon />
            </a>
          )}
        </Modal.Header>
        <Modal.Body>
          <Form stato={this.state} onChange={this.updateForm} ref={r => this.form = r}>
            <Grid fluid className="pl-0 pr-0">
              {!datiIniziali
                && (
                  <Grid.Row>
                    <Grid.Col md="6">
                      <Input
                        name="CodiceFiscale"
                        title="Codice fiscale"
                        disabled={datiIniziali}
                        validations={['required', 'CodiceFiscaleAlfaNumericoTrimmed']}
                        onPaste={this.incolla}
                        onChange={this.valutaEsistenzaAnagrafica}
                        ref={r => this.cfInput = r}
                      />
                    </Grid.Col>
                  </Grid.Row>
                )
              }
              {!datiIniziali
                && (
                  <Grid.Row>
                    <Grid.Col md="6">
                      <Input
                        name="Cognome"
                        title="Cognome"
                        validations={['required', 'ValidaCognome']}
                        disabled={bloccaInserimento}
                      />
                    </Grid.Col>
                    <Grid.Col md="6">
                      <Input
                        name="Nome"
                        title="Nome"
                        validations={['required', 'ValidaNome']}
                        disabled={bloccaInserimento}
                      />
                    </Grid.Col>
                  </Grid.Row>
                )
              }

              {renderMessaggi(dichiarazioneEsistente, this.state.TipoDichiarazione, this.state.CodiceFiscale.length >= 16 ? this.state.CodiceFiscale : null)}

              {messaggioErrore && <Panel error>{messaggioErrore}</Panel>}

              {tipoDichiarazione == _tipoDichiarazione.INTEGRATIVA
                && (
                  <Fragment>
                    <Grid.Row className="mt-8">
                      <Grid.Col md="12">
                        <Grid fluid>
                          <Grid.Row>
                            <Grid.Col md="6">
                              <Grid.Row>
                                <label><Radio name="TipoDichiarazione" disabled={!impostazioni || !impostazioni.CampagnaIntegrativiCodice1e3Aperta} value={TipoDichiarazione.SetteTrentaIntegrativaCodice1} />Integrativa codice 1</label>
                              </Grid.Row>
                              <Grid.Row>
                                <label><Radio name="TipoDichiarazione" disabled={!impostazioni || !impostazioni.CampagnaIntegrativiCodice2Aperta} value={TipoDichiarazione.SetteTrentaIntegrativaCodice2} />Integrativa codice 2</label>
                              </Grid.Row>
                              <Grid.Row>
                                <label><Radio name="TipoDichiarazione" disabled={!impostazioni || !impostazioni.CampagnaIntegrativiCodice1e3Aperta} value={TipoDichiarazione.SetteTrentaIntegrativaCodice3} />Integrativa codice 3</label>
                              </Grid.Row>
                            </Grid.Col>
                            <Grid.Col md="6">
                              <Grid.Row>
                                <Input name="Protocollo" title={this.titleProtocollo()} validations={this.validaProtocollo(annoSelezionato)} disabled={this.abilitaProtocollo()} maxLength="17" />
                              </Grid.Row>
                            </Grid.Col>
                          </Grid.Row>
                        </Grid>
                      </Grid.Col>
                    </Grid.Row>

                    {this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2 && sostitutoPrecedente != null && sostitutoPrecedente.IdSostituto != null
                      && (
                        <Fragment>
                          <Grid.Row>
                            <Grid.Col md="12">
                              <Heading as="h6" className="mt-8">Sostituto d'imposta attuale</Heading>
                            </Grid.Col>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Col md="4">
                              <Textblock label="Denominazione" text={this.state.sostitutoPrecedente.Denominazione} />
                            </Grid.Col>
                            <Grid.Col md="4">
                              <Textblock label="Codice fiscale" text={this.state.sostitutoPrecedente.CodiceFiscale} />
                            </Grid.Col>
                            <Grid.Col md="4">
                              <Textblock label="Codice sede" text={this.state.sostitutoPrecedente.CodiceSede} />
                            </Grid.Col>
                          </Grid.Row>
                        </Fragment>
                      )
                    }

                    {
                      this.state.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2 && messaggioErrore == null && (sostitutoPrecedente == null || (sostitutoPrecedente != null && sostitutoPrecedente.IdSostituto != null))
                      && (
                        <Fragment>
                          <hr />
                          <Grid.Row>
                            <Grid.Col md="12">
                              <Heading as="h5" className="mt-8">Modifica sostituto di imposta</Heading>
                            </Grid.Col>
                          </Grid.Row>


                          <Grid.Row>
                            <Grid.Col md="4">
                              <label className="mt-19"><Radio name="SceltaSostituto" value="1" onChange={this.changeSceltaSostituto} />Con sostituto</label>
                            </Grid.Col>
                            <Grid.Col md="4">
                              <label className="mt-19"><Radio name="SceltaSostituto" value="0" onChange={this.changeSceltaSostituto} />Senza sostituto</label>
                            </Grid.Col>

                          </Grid.Row>
                          {this.state.SceltaSostituto == 0
                            ? (
                              <Grid.Row>
                                {dichiarazioneEsistente != null && (dichiarazioneEsistente.DaTrattenere7304 || 0) > 0 && (dichiarazioneEsistente.DaRimborsare7304 || 0) == 0
                                  && (
                                    <Grid.Col md="4">
                                      <Select name="DataPrimaRata" validations={['required']}>
                                        <Select.Option value="1">30 Giugno</Select.Option>
                                        <Select.Option value="2">30 Luglio</Select.Option>
                                      </Select>
                                    </Grid.Col>
                                  )
                                }
                                {dichiarazioneEsistente != null && ((dichiarazioneEsistente.DaTrattenere7304 || 0) == 0 && (dichiarazioneEsistente.DaRimborsare7304 || 0) > 0)
                                  && (
                                    <Grid.Col md="8">
                                      <Input
                                        disabled={this.state.SceltaSostituto != 0}
                                        maxLength={27}
                                        name="CodiceIban"
                                        validations={['IBAN']}
                                        title="Codice IBAN"
                                      />
                                    </Grid.Col>
                                  )
                                }
                              </Grid.Row>
                            )
                            : (
                              <Fragment>
                                <Grid.Row>
                                  <Grid.Col md="6">
                                    <Autocomplete
                                      validations={this.state.SceltaSostituto == 1 ? ['required', 'CodiceFiscale'] : []}
                                      clearAfterSelect={false}
                                      url={`/api/V1/SostitutoImposta/CercaSostitutiPerUfficio?ufficio=${ufficioSelezionato}`}
                                      suggest
                                      minLength={3}
                                      onChange={this.changeCodiceFiscaleSostituto}
                                      renderProperty="CodiceFiscale"
                                      renderRow={item => `${item.CodiceFiscale} ${item.CodiceSede > 0 ? ` - ${item.CodiceSede} ` : ''} - ${item.Denominazione}`}
                                      disabled={this.state.SceltaSostituto != 1}
                                      name="CodiceFiscaleSostituto"
                                      title="Codice fiscale sostituto"
                                    />
                                  </Grid.Col>
                                  {this.state.Sostituto
                                    && this.state.Sostituto.IdSostituto
                                    && (
                                      <Grid.Col md="5">
                                        <small>
                                          <div className="mt-10 text--center">
                                            Per la modifica dei dati di un sostituto già presente in archivio, accedere all’archivio sostituti
                                          </div>
                                        </small>
                                      </Grid.Col>
                                    )
                                  }
                                  <Grid.Col md="1">
                                    <a
                                      target="_blank"
                                      href={`${window.config.urlAssistente}/#/Area/1/Dossier/182/Contenuto/15119`}
                                      className="infoTooltip"
                                      style={{ position: 'absolute', top: '30px', left: '-5px' }}
                                    >
                                      <InfoesIcon />
                                    </a>
                                  </Grid.Col>
                                </Grid.Row>
                                <Grid.Row>
                                  <Grid.Col md="9">
                                    <Input
                                      name="Sostituto.Denominazione"
                                      validations={this.state.SceltaSostituto == 1 ? ['required'] : []}
                                      title="Denominazione"
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                    />
                                  </Grid.Col>
                                  <Grid.Col md="3">
                                    <Input
                                      name="Sostituto.CodiceSede"
                                      title="Codice sede"
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                    />
                                  </Grid.Col>
                                </Grid.Row>
                                <Grid.Row>
                                  <Grid.Col md="8">
                                    <Autocomplete
                                      name="Sostituto.DescrizioneComune"
                                      title="Comune"
                                      clearAfterSelect={false}
                                      minLength={2}
                                      url="/api/V1/SostitutoImposta/CercaComune"
                                      onChange={this.changeComuneSostituto}
                                      validations={this.state.SceltaSostituto == 1 ? ['required'] : []}
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                      value={DescrizioneComune}
                                      renderProperty="Descrizione"
                                      renderRow={null}
                                    />
                                  </Grid.Col>
                                  <Grid.Col md="2">
                                    <Input
                                      name="Sostituto.CodiceProvincia"
                                      title="Provincia"
                                      disabled
                                    />
                                  </Grid.Col>
                                  <Grid.Col md="2">
                                    <Input
                                      name="Sostituto.Cap"
                                      title="CAP"
                                      validations={this.state.SceltaSostituto == 1 ? ['required'] : []}
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                    />
                                  </Grid.Col>
                                </Grid.Row>
                                <Grid.Row>
                                  <Grid.Col md="3">
                                    <Autocomplete
                                      name="Sostituto.TipologiaIndirizzo"
                                      clearAfterSelect={false}
                                      minLength={3}
                                      validations={this.state.SceltaSostituto == 1 ? ['required'] : []}
                                      onChange={this.changeTipoIndirizzoSostituto}
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                      renderProperty="Descrizione"
                                      renderRow={null}
                                      title="Tipo indirizzo"
                                      url="/api/V1/SostitutoImposta/CercaTipoIndirizzo"
                                      value={TipologiaIndirizzo}
                                    />
                                  </Grid.Col>
                                  <Grid.Col md="7">
                                    <Input
                                      name="Sostituto.Indirizzo"
                                      title="Indirizzo"
                                      maxLength="255"
                                      validations={this.state.SceltaSostituto == 1 ? ['required'] : []}
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                    />
                                  </Grid.Col>
                                  <Grid.Col md="2">
                                    <Input
                                      name="Sostituto.NumeroCivico"
                                      title="N. civico"
                                      disabled={!this.state.Sostituto || this.state.Sostituto.IdSostituto}
                                    />
                                  </Grid.Col>
                                </Grid.Row>
                              </Fragment>
                            )
                          }
                        </Fragment>
                      )
                    }
                  </Fragment>
                )
              }
            </Grid>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button flat onClick={this.annulla}>Annulla</Button>
          {renderPulsanti(dichiarazioneEsistente, this.state.TipoDichiarazione, this.crea, this.modifica, this.visualizza, this.ripristina)}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleCreazione.TipoDichiarazione = _tipoDichiarazione;

ModaleCreazione.propTypes = {
  datiIniziali: PropTypes.object,
  isLoading: PropTypes.bool,
  messaggioErrore: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  onAnnulla: PropTypes.func.isRequired,
  onCreaNuova: PropTypes.func,
  onRipristinaEliminata: PropTypes.func,
  showModal: PropTypes.bool.isRequired,
  tipoDichiarazione: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  ufficioSelezionato: PropTypes.string,
  annoSelezionato: PropTypes.number,
};

ModaleCreazione.defaultProps = {
  tipoDichiarazione: _tipoDichiarazione.NON_SELEZIONATO,
};

export default ModaleCreazione;
